import {GameObject} from "../base/GameObject";
import {SpineMovie} from "./SpineMovie";

export class LibrarySpine extends GameObject {

  private readonly _skeletonName!: string;
  private readonly _atlasName!: string;

  constructor(skeletonName: string, atlasName: string) {
    super();
    this._skeletonName = skeletonName;
    this._atlasName = atlasName;
  }

  unloadAssets() {
    // TODO!!!!!!!!
  }

  public createSpineMovie(): SpineMovie {
    return new SpineMovie(this._skeletonName, this._atlasName);
  }

  override destroy(): void {
    this.unloadAssets();
    super.destroy();
  }
}
